import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class RouteMobileService {

    // Get all Route Mobiles
    static async getRouteMobiles(params = {}) {
        const response = await axiosInstance.get(
            API_PATHS.getroutemobiles,
            { params }
        );

        return response.data;
    }

    // Get Route Mobile by ID
    static async getRouteMobileById(id) {
        const url = API_PATHS.getroutemobile.replace(":id", id);

        const response = await axiosInstance.get(url);

        return response.data;
    }

    // Add Route Mobile
    static async addRouteMobile(payload) {
        const response = await axiosInstance.post(
            API_PATHS.addroutemobile,
            payload
        );

        return response.data;
    }

    // Update Route Mobile
    static async updateRouteMobile(id, payload) {
        const url = API_PATHS.updateroutemobile.replace(":id", id);

        const response = await axiosInstance.put(
            url,
            payload
        );

        return response.data;
    }
}

export default RouteMobileService;